import React, { useState, useMemo } from 'react'; // useMemo kept for search
import { Link, NavLink } from 'react-router-dom';
import MenuBar from '../MenuBar';
import Sidebar from '../Sidebar';
import Footer from '../Footer';
import DepartmentsData from './DepartmentsData';

const DepartmentsPage = () => {
  const [search, setSearch] = useState('');

  const filtered = useMemo(() => {
    return DepartmentsData.filter(d =>
      d.name.toLowerCase().includes(search.toLowerCase()) ||
      d.coordinator.toLowerCase().includes(search.toLowerCase())
    );
  }, [search]);

  return (
    <>
      <MenuBar />
      <Sidebar />

      {/* Page Banner */}
      <section className="page-banner">
        <div className="image-layer"></div>
        <div className="auto-container">
          <h1>YK-USA Coordination Team</h1>
        </div>
        <div className="breadcrumb-box">
          <div className="auto-container">
            <ul className="bread-crumb clearfix">
              <li><NavLink to="/USA/Home">Home</NavLink></li>
              <li className="active">Departments</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="dept-list-page">
        <div className="auto-container" style={{ paddingTop: '60px' }}>

          {/* Header */}
          <div className="dept-section__header" style={{ marginBottom: '36px' }}>
            <div className="dept-badge">
              <i className="fas fa-users"></i>
              YK-USA
            </div>
            <h2>Coordination Team</h2>
            <p>Explore all {DepartmentsData.length} departments that power Yugal Kunj USA Atlanta</p>
          </div>

          {/* Search + Filter */}
          <div className="d-flex align-items-center gap-3 flex-wrap justify-content-center mb-4">
            <div className="dept-search-wrap">
              <i className="fas fa-search dept-search-icon"></i>
              <input
                type="text"
                placeholder="Search departments or coordinators..."
                value={search}
                onChange={e => setSearch(e.target.value)}
              />
            </div>
          </div>

          {/* Cards Grid */}
          {filtered.length === 0 ? (
            <div className="dept-empty">
              <i className="fas fa-search-minus"></i>
              <p>No departments found matching your search.</p>
            </div>
          ) : (
            <div className="dept-list-grid">
              {filtered.map(dept => (
                <Link
                  key={dept.id}
                  to={`/USA/departments/${dept.slug}`}
                  className="dept-list-card"
                  style={{ '--dept-gradient': dept.gradient }}
                >
                  <div className="dlc-body">
                    <div className="dlc-icon">
                      <i className={`fas ${dept.icon}`}></i>
                    </div>
                    <p className="dlc-name">{dept.name}</p>
                    <p className="dlc-coord">{dept.coordinator}</p>
                    <p className="dlc-desc">{dept.description}</p>
                    <div className="dlc-footer">
                      <span className={`dlc-type ${dept.type === 'Public Facing' ? 'is-public' : 'is-private'}`}>
                        <span className="type-dot"></span>
                        {dept.type}
                      </span>
                      <span className="dlc-link">
                        View Details <i className="fas fa-arrow-right"></i>
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}

          {/* CTA */}
          <div className="dept-section__cta">
            <a
              href="https://portalyk.yugalkunj.org/#/volunteer/register"
              target="_blank"
              rel="noreferrer"
              className="dept-cta-btn"
            >
              Join Our Mission <i className="fas fa-arrow-right"></i>
            </a>
            <p>Be part of something greater — volunteer with us today</p>
          </div>

        </div>
      </div>

      <Footer />
    </>
  );
};

export default DepartmentsPage;
